<template>
  <div class="content">
    <div class="user_info">
      <img class="img" :src="iepUserDTO && iepUserDTO.headPicUrl" alt="" />
      <div class="info">
        <div class="txt1">
          {{ iepUserDTO && iepUserDTO.realName }}
        </div>
        <div class="txt2">
          <span class="txt2-time">{{ detailData && detailData.times }}</span>
        </div>
      </div>
    </div>
    <div class="all">
      <p class="title">{{ detailData && detailData.title }}</p>
      <div class="doc_open">
        <div class="doc_content" :class="!isOpen ? 'open' : ''" v-html="detailData.content"></div>
        <div v-if="showBtn" class="btn" :class="isOpen ? 'open' : 'close'" @click="isOpen = !isOpen">{{ isOpen ? '收起' : '展开' }}</div>
      </div>
      <!-- 视频 -->
      <div class="video-block" v-if="analysisVideo && Object.keys(analysisVideo).length > 0">
        <video :src="analysisVideo && analysisVideo.url" controls class="video"></video>
      </div>
      <div class="img-cover-list" v-else-if="files.length > 0 && !detailData.adminMaterialVideoId">
        <img v-for="(item_img, index_img) in files" :key="index_img" :src="item_img.url" @click="handleClickImg(index_img)" class="img-cover" alt="" />
      </div>
      <div class="custom-mask" @click="hidePreviewIfMaskClicked">
        <van-image-preview ref="imagePreview" v-model="showPreview" :images="images" :closeable="true" :start-position="initialIndex" />
      </div>
    </div>
    <div class="file-div" :class="workType === 'correct' ? 'correct' : ''">
      <div class="div-label">文件</div>
      <div class="div-con" v-if="filePdf && Object.keys(filePdf).length > 0" @click="handleClick">
        {{ `${filePdf.title}.${filePdf.format}` }}
        <img v-if="isTutorAndPeSign" src="../../assets/images/zone/img45.png" class="icon-upload" @click.stop="handleDownLoad(filePdf)" alt="">
      </div>
      <div class="div-con" v-else>暂未上传</div>
    </div>
    <!-- <div class="work-txtarea" v-if="workType === 'correct'">
      <div class="tip">导师评语</div>
      <van-field v-model="message" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入评语" />
    </div> -->
    <div class="work-txtarea" v-if="detailData && detailData.approvalWorkTime">
      <div class="tip">导师评语</div>
      <van-field :value="detailData && detailData.approvalWorkNote" disabled rows="3" autosize type="textarea" maxlength="100" placeholder="请输入评语" />
    </div>
    <div class="work-txtarea work-txtarea2" v-if="detailData.approvalWorkTime > 0">
      <div class="tip">评语导师：</div>
      <div class="txts">{{ detailData.tuTorInfoDTO && Object.keys(detailData.tuTorInfoDTO).length > 0 ? detailData.tuTorInfoDTO.realName : iepUserDTO.realName }}</div>
    </div>
    <template v-if="`${zoneRoles.peSign}` !== '1' && `${userInfo.memberType}` !== '1'">
      <!-- <div class="submit-btn isCorrected" v-if="workType === 'correct' && detailData.approvalWorkNote">已提交评语</div> -->
      <!-- <div class="submit-btn isCorrect" v-else-if="workType === 'correct'" @click="handleCorrectWork">提交评语</div> -->
       <img src="../../assets/images/zone/img44.png" v-if="workType === 'correct' && !detailData.approvalWorkNote" @click="correctOverlay = true" class="correct-btn" alt="">
      <template v-if="detailData.areaPostbarInfoDTO && `${detailData.areaPostbarInfoDTO.isCutTime}` === '1'">
        <div class="submit-btn isComment" v-if="workType === 'answer' && !detailData.approvalWorkTime">已提交</div>
        <div class="submit-btn edit" v-if="workType === 'answer' && !detailData.approvalWorkTime" @click="handleGo">编辑内容</div>
      </template>
    </template>
    <returnBack></returnBack>
    <van-overlay :show="correctOverlay" @click="correctOverlay = false">
      <div class="wrapper" @click.stop>
        <div class="work-txtarea">
          <div class="tip">导师评语</div>
          <van-field v-model="message" rows="8" autosize type="textarea" maxlength="100" placeholder="请输入评语" show-word-limit />
          <div class="submit-btn isCorrect" @click="handleCorrectWork">提交评语</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showLoading" @click="showLoading = false">
      <div class="wrapper-loading" @click.stop>
        <van-loading type="spinner" vertical>下载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { workDetails, correctWork } from '@/api/zone'
import { allVideo, roleIsConsumer, rolesClick } from './data'
import returnBack from './compontents/returnBack.vue'
import {ImagePreview} from 'vant'
import axios from 'axios'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    returnBack,
    ImagePreview
  },
  data () {
    return {
      detailData: {},
      iepUserDTO: {},
      files: [],
      analysisVideo: {},
      isPlayVideo: true,
      filePdf: {},
      workType: '',
      message: '',
      zoneRoles: {},
      isOpen: true,
      showBtn: false,
      correctOverlay: false,
      showPreview: false,
      images: [],
      initialIndex: 0,
      isDragging: false,
      dragStartX: 0,
      showLoading: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    isTutorAndPeSign () {
      return !(`${this.zoneRoles.peSign}` !== '1' && `${this.zoneRoles.tutorSign}` !== '1' && `${this.userInfo.memberType}` !== '1')
    },
  },
  mounted () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    this.zoneRoles = role
    if (this.$route.query.workType === 'correct') {
      if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo)) {
        this.$router.push({
          path: `/zoneDetails?areaId=${this.$route.query.areaId}`
        })
        return
      }
    }
    this.workType = this.$route.query.workType
    this.handleFun()
  },
  methods: {
    handleMouseDown (event) {
      if (!this.showPreview || event.buttons !== 1) return // 只处理左键按下

      // 开始拖动
      this.isDragging = true
      this.dragStartX = event.clientX

      // 添加鼠标移动和释放的监听器
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    },
    handleMouseMove (event) {
      if (!this.isDragging) return

      // 计算拖动距离
      this.deltaX = event.clientX - this.dragStartX

      // 重置起点
      // this.dragStartX = event.clientX
    },
    handleMouseUp () {
      if (!this.isDragging) return
      // 根据拖动方向切换图片
      if (this.deltaX > 50 && this.initialIndex > 0) {
        this.initialIndex--
      } else if (this.deltaX < -50 && this.initialIndex < this.images.length - 1) {
        this.initialIndex++
      }
      // 结束拖动
      this.isDragging = false
      // 移除鼠标移动和释放的监听器
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.handleMouseUp)
    },
    // 点击关闭
    hidePreviewIfMaskClicked (event) {
      // 判断点击是否发生在预览图片本身之外
      if (event.target.classList.contains('van-image-preview__swipe-item')) {
        this.showPreview = false
        document.removeEventListener('mousedown', this.handleMouseDown)
      }
    },
    // 点击放大图片
    handleClickImg (index) {
      this.images = this.files.map(res => res.url)
      this.initialIndex = index
      this.showPreview = true
      document.addEventListener('mousedown', this.handleMouseDown)
    },
    handleGetRoles(areaId) {
      this.zoneRoles = JSON.parse(sessionStorage.getItem('roleResult'))
    },
    async handleClick12(file) {
      try {
        const response = await axios({
          url: file.url,
          method: 'GET',
          responseType: 'blob', // 必须指定为blob类型才能下载
        })
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = file.url
        let fileName = file.title || 'default_name' // 提供一个默认值以防止 file.title 为 undefined
        let fileFormat = file.format || 'pdf' // 提供一个默认值以防止 file.format 为 undefined
        let encodedFileName = `${encodeURIComponent(fileName)}.${fileFormat}`
        link.setAttribute('download', encodedFileName) // 或者根据实际情况获取文件名
        // link.setAttribute('download', `${file.title}.${file.format}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url) // 清理内存中的对象URL
      } catch (error) {
        console.error('下载PDF时发生错误:', error)
      }
    },
    handleClick () {
      const curFileSize = parseFloat(this.filePdf.size.replace(/[^.\d]/g, ''))
      const curFileFormat = this.filePdf.size.substring(this.filePdf.size.length - 2, this.filePdf.size.length)
      if (curFileSize > 50 && curFileFormat === 'MB') {
        this.$toast('因文件过大，暂不支持预览，已为您下载至本地查看')
        this.handleDownLoad(this.filePdf)
      } else {
        if (this.filePdf.url.indexOf('pdf') > -1) {
          this.$router.push({
            path: `/pdfView?pdfUrl=${this.filePdf.url}&areaId=${this.$route.query.areaId}`
          })
        } else {
          this.$router.push({
            path: `/pptView?pptSrc=${this.filePdf.url}&areaId=${this.$route.query.areaId}`
          })
        }
      }
    },
    handleFun () {
      let workId = this.$route.query.workId
      workDetails({ workId: workId }).then(res => {
        this.detailData = res.data
        this.iepUserDTO = this.detailData.iepUserInfoDTO
        this.detailData.times = this.$moment(this.detailData.createTime * 1).format('MM-DD HH:mm')
        if (res.data.approvalWorkNote) {
          this.message = res.data.approvalWorkNote
        }
        this.files = res.data.files.filter(item => {
          if (item.format === 'pdf' || item.format.indexOf('ppt') > -1) {
            this.filePdf = item
          }
          return item.id !== this.filePdf.id
        })
        if (this.files.length === 1 && allVideo.indexOf((this.files[0].format).toLocaleLowerCase()) > -1) {
          this.analysisVideo = this.files[0]
        }
        const getPlainTextLen = richText => richText
          .replace(/<[^>]+>/g, '')
          .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
          .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
          .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
          .length
        if (this.detailData.content && getPlainTextLen(this.detailData.content) > 100) {
          this.showBtn = true
        }
        this.handleGetRoles(res.data.areaPostbarInfoDTO.areaId)
      })
    },
    handleClickItemsVideo () {
      this.isPlayVideo = !this.isPlayVideo
      setTimeout(() => {
        let videos = this.$refs.video
        videos.player.play()
      })
    },
    handleGo () {
      this.$router.push({
        path: `/answerWork?postId=${this.detailData.postbarId}&workId=${this.$route.query.workId}&areaId=${this.zoneRoles.areaId}`
      })
    },
    handleCorrectWork () {
      if (!this.message) {
        this.$toast('请填写评语！')
        return
      }
      let params = {
        workId: this.$route.query.workId,
        approvalWorkNote: this.message
      }
      correctWork(params).then(res => {
        this.$toast('提交成功')
        // this.handleFun()
        setTimeout(() => {
          this.$router.back()
        }, 500)
      })
    },
    async handleDownLoad(file) {
      this.showLoading = true
      try {
        const response = await fetch(file.url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let fileName = file.title || 'default_name' // 提供一个默认值以防止 file.title 为 undefined
        let fileFormat = file.format || 'pdf' // 提供一个默认值以防止 file.format 为 undefined
        let encodedFileName = `${fileName}.${fileFormat}`
        link.setAttribute('download', encodedFileName) // 或者根据实际情况获取文件名
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
      } catch (error) {
        console.error('Download failed:', error)
      } finally {
        this.showLoading = false
      }
    }

  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.content {
  padding: 0 0 50px;
  box-sizing: border-box;
  padding-bottom: 200px;

  .user_info {
    display: flex;
    align-items: center;
    width: 100%;
    height: 64px;
    margin-bottom: 10px;
    padding: 10px 16px;
    box-sizing: border-box;
    background-image: url('../../assets/images/zone/img43.png');
    background-size: 100% 100%;

    .img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 8px;
      display: block;
    }

    .info {
      .txt1 {
        line-height: 20px;
        font-size: 14px;
        color: #EB1700;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        margin-bottom: 2px;
      }

      .txt2 {
        .txt2-time {
          font-size: 12px;
          font-weight: 500;
          color: #7a8494;
          font-family: Source Han Sans CN, Source Han Sans CN;
        }
      }
    }
  }

  .all {
    padding: 0 16px;
    box-sizing: border-box;
  }

  .title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 18px;
    color: #282828;
    padding: 8px 0;
    box-sizing: border-box;
  }
  .doc_open {
    .doc_content {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 30px;
      &.open {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }
    }
    .btn {
      width: 100%;
      font-family: PingFang HK, PingFang HK;
      font-size: 14px;
      line-height: 20px;
      color: #EB1700;
    }
  }
}

.img-cover-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  .img-cover {
    width: 110px;
    height: 110px;
    border-radius: 4px;
    margin-bottom: 4px;
    object-fit: cover;
    display: block;
    &:nth-child(3n-1) {
      margin: 0 4px;
    }
  }
}

.video-block {
  width: 100%;
  height: 200px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .video {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
}

.file-div {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  font-size: 14px;
  color: #343434;
  // position: fixed;
  // bottom: 150px;
  // left: 14px;
  margin-left: 14px;
  width: calc(100% - 28px);
  background-color: #fff;
  z-index: 9;

  &.correct {
    bottom: 0;
    position: relative;
  }

  .div-con {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .icon-upload {
      width: 18px;
      height: 18px;
      display: block;
      margin-left: 20px;
    }
  }
}

.work-txtarea {
  margin: 0 14px;
  &.work-txtarea2 {
    display: flex;
    align-items: center;
  }
  .tip, .txts {
    font-size: 16px;
    color: #202020;
    font-weight: bold;
    line-height: 20px;
    padding-top: 16px;
    margin-bottom: 8px;
  }

  /deep/.van-field {
    padding-left: 0;
    padding-right: 0;
  }
}
.correct-btn {
  width: 123px;
  height: 42px;
  position: fixed;
  bottom: 40px;
  right: 14px;
}
.submit-btn {
  background: #EB1700;
  box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
  border-radius: 100px;
  width: 343px;
  height: 42px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 42px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;

  &.isComment {
    background: #EBEBEB;
    color: #7A8494;
    box-shadow: none;
    bottom: 90px;
  }

  &.isCorrect {
    bottom: 40px;
  }

  &.isCorrected {
    background: #EBEBEB;
    box-shadow: none;
    color: #7A8494;
  }

  &.edit {
    color: #7A8494;
    background: transparent;
    bottom: 40px;
    box-shadow: none;
  }
}
/deep/ .van-overlay {
  z-index: 99;
  .work-txtarea {
    position: absolute;
    width: 100%;
    left: 0;
    margin: 0;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    background-color: #fff;
    bottom: 0;
    padding: 32px 16px;
    box-sizing: border-box;
    height: 400px;
    .tip {
      padding-top: 0;
      margin-bottom: 0;
    }
  }
}

.wrapper-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/RTCZone/workDetails.vue